import { useViewportSize as useBriqCommonViewportSize, ViewPortSize as BriqCommonViewPortSize } from '@briq/shared'

export type DeviceType = BriqCommonViewPortSize.DeviceType

export type ViewportDimensions = BriqCommonViewPortSize.ViewportDimensions

export function useViewportSize(): undefined | ViewportDimensions {
  return useBriqCommonViewportSize()
}
